// Module
var code = "<div class=\"panel-heading-buttons pull-right\"> <i class=\"fa fa-fw fa-minus\" ng-click=\"vm.less()\" ng-if=\"vm.hasLess\" title=\"{{(vm.lessText ? vm.lessText : 'Less')|translate}}\"></i> <i class=\"fa fa-fw fa-plus\" ng-click=\"vm.more()\" ng-if=\"vm.hasMore\" title=\"{{(vm.moreText ? vm.moreText : 'More')|translate}}\"></i> </div>";
// Exports
module.exports = code;